var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex gap-2 align-items-center flex-wrap"},[(_vm.isLoading)?_c('div',{staticClass:"w-100 d-flex justify-content-center"},[_c('b-spinner')],1):_vm._l((_vm.featuredTags),function(tag){return _c('TaggingBadge',{key:tag.id,attrs:{"label":tag.name,"variant":tag.color_variant}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }